import transportPointTrip from "../components/views/transportPointTrip/transportPointTrip.vue";
import createTransportPointTrip from "../components/views/transportPointTrip/createTransportPointTrip.vue";
import viewTransportPointTrip from "../components/views/transportPointTrip/viewTransportPointTrip.vue";
const routes = [
  {
    path: "Segregation-plant-trip",
    component: transportPointTrip,
    name: "transportPointTrip",
    meta: {
      description: "List of Segregation Plant Trips",
      title: "Segregation Plant Trip",
      requiresAuth: true,
    },
  },

  {
    path: "Segregation-plant-trip/create-Segregation-plant-trip/:_id",
    component: createTransportPointTrip,
    name: "createTransportPointTrip",
    meta: {
      //   description: "",
      title: "Add / Update Segregation Plant Trip",
      requiresAuth: true,
    },
  },
  {
    path: "Segregation-plant-trip/view-segregation-Plant/:_id",
    component: viewTransportPointTrip,
    name: "viewTransportPointTrip",
    meta: {
      description: "",
      title: "Segregation Plant Trip",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/transportPointTrip.route.js